export default __webpack_public_path__ + "static/media/zip9.ef0ee2c2.txt";